/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import * as moment from 'moment';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class TrafficHistogramApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(
    objectId: string | null,
    param: string | null,
    types: string[],
    filter: Record<string, string[]>,
    startDate: moment.Moment | null,
    endDate: moment.Moment | null,
    suppressAdUnitBreakdown: boolean
  ): Observable<any> {
    const body: Record<string, any> = {
      types: types || [],
      filter: filter || {},
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
      suppressAdUnitBreakdown
    };
    if (objectId && param) {
      body[param] = objectId;
    }
    return this.client.request({
      method: 'POST',
      url: this.apiConfig.getVersionedUri('traffichistogram'),
      body
    });
  }
}
